module.exports = __webpack_public_path__ + "img/beer_id-0.3993d701.png";